/* Package JSON Import will be here */
import CryptoJS from 'crypto-js';
/* Package JSON Import will be here */

/* Const,Let & Var will be here */
const privateKey = "5Ht#9P$@2L!&zE*FqY7WuRv3^Gx@jKm";
/* Const,Let & Var will be here */

/* Encrypt the string and return the encrypted string */
export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(data, privateKey).toString();
};

/* Decrypt the encrypted string and return the encrypted string */
export const decryptData = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, privateKey);
    return bytes.toString(CryptoJS.enc.Utf8);
};
